import React, { useRef} from 'react';
import { useNavigate } from "react-router-dom";
import { listTypes, urls, actionTypes, documentStatuses, alfrescoTypes } from '../../constants.js';
import { Button, Dropdown } from 'react-bootstrap';
import { submitAction } from '../helpers/HelperFunctions.js';
import { showModalDialog, hideModalDialog, yesNoDialog, messageDialog } from '../ModalDialog.js';
import i18next from "../../i18n.js";
import SignDocumentForm from '../forms/SignDocumentForm.js';
import { CommentForm } from '../comments/CommentForm.js';
import DocumentItemField from './DocumentItemField.js';

const DocumentItem = (props) => {
    const navigate = useNavigate();
    const dateField = props.doc.fields.find(f => f.name === 'CreateDate');
    const startDateField = props.doc.fields.find(f => f.name === 'ClaimDateStart');
    const endDateField = props.doc.fields.find(f => f.name === 'ClaimDateEnd');
    const creatorField = props.doc.fields.find(f => f.name === 'Creator');
    const creatorValueField = props.doc.fields.find(f => f.name === 'Creator_value');
    const creatorAvatarField = props.doc.fields.find(f => f.name === 'AvatarNodeRef');
    const typeName = props.doc.fields.find(f => f.name === 'TypeName');

    const actionsRef = useRef(null);

    if (startDateField.value && startDateField.value.split(' - ').length < 2) {
        startDateField.value = `${startDateField.value} - ${endDateField.value}`;
    }

    if (creatorField) {
        creatorField.props = {
            login: creatorValueField?.value,
            avatarId: creatorAvatarField?.value?.split('/').pop()
        };
    }

    let fields = props.doc.fields.filter(f => f.name !== 'ClaimDate' && f.name !== 'CreateDate' && f.name !== 'ClaimDateEnd' && props.fieldSettings?.find(s => s.name === f.name).visible);
    fields = fields.sort((f1, f2) => props.fieldSettings?.find(s => s.name === f1.name).orderIndex - props.fieldSettings?.find(s => s.name === f2.name).orderIndex);
    if (typeName?.value === alfrescoTypes.unstructuredDocument) {
        fields = fields.filter(f => f.name !== 'DocKind');
    }

    const onClick = (e) => {
        if (actionsRef.current && actionsRef.current.contains(e.target)) {
            return;
        }
        switch (props.type) {
            case listTypes.Documents:
                navigate(`${urls.documentsPage}/${props.doc.id}?return=${document.location.pathname}${document.location.search}`);
                break;
            case listTypes.Tasks:
                const docId = props.doc.fields.find(f => f.name === 'DocumentNodeRef').value.split('/').pop();
                const stateValue = props.doc.fields.find(f => f.name === 'StateValue')?.value;
                if ((stateValue === documentStatuses.processingTravelLetterAuto || stateValue === documentStatuses.formationReport || stateValue === documentStatuses.refinementAdvanceReport || stateValue === documentStatuses.refinementSeconded)
                    && props.doc.actions?.some(act => act.type === actionTypes.edit)) {
                    let editIds = localStorage.getItem('edtIds')?.split(';');
                    if (!editIds) {
                        editIds = [];
                    }
                    editIds.push(docId);
                    localStorage.setItem('edtIds', editIds.join(';'));
                }
                navigate(`${urls.tasksPage}/${props.doc.id}?docId=${docId}&return=${document.location.pathname}${document.location.search}`);
                break;
        }
    }

    const onAction = (actionType) => {
        const docId = props.doc.fields.find(f => f.name === 'DocumentNodeRef').value.split('/').pop();
        switch (actionType) {
            case actionTypes.signAdditionalContent:
            case actionTypes.sign: {
                const stateValue = props.doc.fields.find(f => f.name === 'StateValue')?.value;

                if (stateValue === documentStatuses.processingTravelLetterAuto || stateValue === documentStatuses.refinementSeconded) {
                    fetch(`/api/document/CheckInputPage/${docId}`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
                        .then((response) => response.text())
                        .then((result) => {
                            if (result === 'true') {
                                showModalDialog('modalDialog', i18next.t('document.signFormTitle'), '', <SignDocumentForm docId={docId} taskId={props.doc.id} onError={() => hideModalDialog('modalDialog')} />, 'feedPopup', true, []);
                            }
                            else {
                                messageDialog(i18next.t('error'), i18next.t('document.signCheckError'));
                            }
                        });
                }
                else {
                    showModalDialog('modalDialog', i18next.t('document.signFormTitle'), '', <SignDocumentForm docId={docId} taskId={props.doc.id} onError={() => hideModalDialog('modalDialog')} />, 'feedPopup', true, []);
                }

                break;
            }
            case actionTypes.cancel: {
                const onReject = (comment) => {
                    submitAction(props.doc.id, docId, actionTypes.cancel, comment.content, (isOk) => {
                        if (isOk) {
                            navigate(0);
                        }
                    });
                }
                showModalDialog('modalDialog', i18next.t('document.regectFormTitle'), "", <CommentForm handleChangeComment={onReject} submitBtnText={i18next.t('document.reject')} cancelBtnText={i18next.t('document.cancel')} />, "feedPopup");
                break;
            }
            case actionTypes.resign: {
                const onSend = (comment) => {
                    submitAction(props.doc.id, docId, actionTypes.resign, comment.content, (isOk) => {
                        if (isOk) {
                            navigate(0);
                        }
                    });
                }
                showModalDialog('modalDialog', i18next.t('document.resignFormTitle'), "", <CommentForm handleChangeComment={onSend} submitBtnText={i18next.t('document.send')} cancelBtnText={i18next.t('document.cancel')} />, "feedPopup");
                break;
            }
            case actionTypes.accept: {
                yesNoDialog(i18next.t('document.taskAcception'), i18next.t('document.acceptTaskMessage'), async () => {
                    submitAction(props.doc.id, docId, actionTypes.accept, '', (isOk) => {
                        if (isOk) {
                            navigate(0);
                        }
                    });
                });
                break;
            }
            case actionTypes.reviewed: {
                const dialogTitle = i18next.t('document.taskReviewed');
                const dialogMessage = i18next.t('document.reviewedTaskMessage');

                yesNoDialog(dialogTitle, dialogMessage, () => {
                    if (!loading) {
                        setLoading(true);
                        submitAction(taskId, docId, actionTypes.reviewed, '', (isOk) => {
                            setLoading(false);
                            if (isOk) {
                                navigate(0);
                            }
                        });
                    }
                });
                break;
            }
            case actionTypes.approve: {
                const onApprove = () => {
                    yesNoDialog(i18next.t('document.taskApproving'), i18next.t('document.approveTaskMessage'), async () => {
                        submitAction(props.doc.id, docId, actionTypes.approve, '', (isOk) => {
                            if (isOk) {
                                navigate(0);
                            }
                        });
                    });
                }

                const stateValue = props.doc.fields.find(f => f.name === 'StateValue')?.value;

                if (stateValue === documentStatuses.formationReport || stateValue === documentStatuses.refinementAdvanceReport || stateValue === documentStatuses.refinementSeconded) {
                    fetch(`/api/document/CheckInputPage/${docId}`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
                        .then((response) => response.text())
                        .then((result) => {
                            if (result === 'true') {
                                onApprove();
                            }
                            else {
                                messageDialog(i18next.t('error'), i18next.t('document.approveCheckError'));
                            }
                        });
                }
                else {
                    onApprove();
                }
                break;
            }
            case actionTypes.edit: {
                let editIds = localStorage.getItem('edtIds')?.split(';');
                if (!editIds) {
                    editIds = [];
                }
                editIds.push(docId);
                localStorage.setItem('edtIds', editIds.join(';'));

                navigate(`${urls.tasksPage}/${props.doc.id}?docId=${docId}&return=${document.location.pathname}${document.location.search}`);
                break;
            }
        }
    }

    return <div className="doc" key={props.doc.id} onClick={onClick} >
        <div className="doc-header">
            <div className="title">{props.doc.title}</div>
            {dateField && <div className="date">{dateField.value}</div>}
        </div>
        <div className="doc-content">
            {fields.map(f => <DocumentItemField key={f.name} field={f} settings={props.fieldSettings?.find(s => s.name === f.name)} />)}
        </div>
        {props.doc.actions && props.doc.actions.length > 0 && <div className="actions" ref={actionsRef} >
            {props.doc.actions.slice(0, 2).map(action => <Button className={action.type} key={action.type} onClick={() => onAction(action.type)}>{action.title}</Button>)}
            {props.doc.actions.length > 2 &&
                <Dropdown align='end'>
                    <Dropdown.Toggle variant='light'>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {props.doc.actions.slice(2, props.doc.actions.length).map((action) => <Dropdown.Item onClick={() => onAction(action.type)}>{action.title}</Dropdown.Item>)}
                    </Dropdown.Menu>
                </Dropdown>
            }
        </div>}
    </div>
}

export default DocumentItem;